// extracted by mini-css-extract-plugin
export var dataCell = "_mc-2";
export var dataRow = "_mc-0";
export var headerRow = "_mc-1";